import { scrollbarStyles } from "@ui/css/01.scrollbar/scrollbar.styles";
import { space } from "ui/src/design-tokens";

export const styles: { [x: string]: { [y: string]: any } } = {
    itemsWrapper: {
        display: "flex",
        flexDirection: "column",
        padding: 6,
        maxWidth: 51,
        overflow: "auto",
        gap: 0.2,
        overflowX: "hidden",
        ...scrollbarStyles,
    },
    sectionWrapper: {
        gap: 2,
        display: "flex",
        height: "100%",
        flexDirection: "column",
    },
    sizesContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        gap: space["0.2"],
        marginY: 1,
        ...scrollbarStyles,
        width: "100%",
    },
    selectDropdownItem: {
        display: "flex",
        justifyContent: "center",
        width: "auto",
        _focus: {
            outline: "none",
            _hover: { outline: "none" },
        },
        _active: {
            outline: "none",
        },
        _focusVisible: {
            outline: "2px solid black",
            zIndex: 1,
        },
        padding: 0,
        _disabled: {
            pointerEvents: "none",
        },
    },
    itemButton: {
        size: "sm",
        fontSize: "desktopBodyTextNormal",
        width: "64px",
        height: 10,
        p: 2,
        _active: {
            outline: "none",
        },
        _focus: {
            outline: "none",
        },
    },
    sizeSectionMainContainer: {
        margin: "auto",
        width: 39,
    },
};
